module.exports = __webpack_public_path__ + "img/bi.89297c15.svg";